export default "__VITE_PUBLIC_ASSET__c0a8801c__"